import '../../assets/scss/adminTopbar.scss';
import { AppLogoHeader } from 'components/_common/Icons';
import HamburgerSvg from 'components/_common/Icons/SVGIcons/HamburgerSvg';
import { useCallback, useEffect } from 'react';
import { Navbar, Container } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { customerMainRoutes } from 'routes/customer/CustomerRoutes';
import {
  loadingNotificationsSelector,
  notificationsSelector,
} from 'store/admin/selectors/AdminGlobalSelector';
import { fetchNotifications, markAllNotificationsRead } from 'store/admin/slices/AdminGlobalSlice';
import { useAppDispatch, useAppSelector } from 'store/hooks';

import GlobalSearchBar from './Sections/GlobalSearchBar';
import NotificationDropdown from './Sections/NotificationDropDown/NotificationDropdown';
import ProfileDropdownMenu from './Sections/ProfileDropdownMenu';
import './../../assets/scss/adminSidebar.scss';

interface TopbarProps {
  setOpenMobileMenu: (v: boolean) => void;
}

const Topbar: React.FC<TopbarProps> = ({ setOpenMobileMenu }) => {
  const dispatch = useAppDispatch();
  const loadingNotifications = useAppSelector(loadingNotificationsSelector);
  const unreadCount = useAppSelector(notificationsSelector)?.unread_count ?? 0;

  useEffect(() => {
    dispatch(fetchNotifications());
  }, [dispatch]);

  // Opening the bell marks everything read; if that fails, refetch so the badge shows the truth.
  const handleNotificationsOpen = useCallback(async () => {
    if (unreadCount === 0) return;
    const result = await dispatch(markAllNotificationsRead());
    if (markAllNotificationsRead.rejected.match(result)) dispatch(fetchNotifications());
  }, [dispatch, unreadCount]);

  return (
    <Navbar className="shadow-sm px-3 position-sticky top-0 top-bar-wrapper topbar">
      <Container fluid className="pe-2 sm-header">
        <div className="d-flex gap-3 profile-left-section">
          {/* <InputGroup className="align-items-center border search-input searchbar-bg me-4">
            <Form.Control type="text" placeholder={t('search')} className="border-0 shadow-none" />
            <InputGroup.Text className="border-0 search-icon">
              <FontAwesomeIcon icon={faMagnifyingGlass} />
            </InputGroup.Text>
          </InputGroup> */}

          <GlobalSearchBar />

          <div
            className="d-md-none d-block position-relative hamburger-icon"
            onClick={() => setOpenMobileMenu(true)}
          >
            <HamburgerSvg width={30} height={30} viewBox="0 -3 22 22" />
          </div>
        </div>

        <div className="logo-collapse">
          {/* same destination as the sidebar logo on web: the customer home page */}
          <Link to={customerMainRoutes.customerHome.path} className="d-flex">
            <img src={AppLogoHeader} alt="logo" />
          </Link>
        </div>

        <div className="d-flex gap-4 profile-right-section">
          <NotificationDropdown loading={loadingNotifications} onOpen={handleNotificationsOpen} />
          <ProfileDropdownMenu />
        </div>
      </Container>
    </Navbar>
  );
};

export default Topbar;
